import React, { useState } from "react";
import "./Criteria.css";

const Criteria = ({ onSearch }) => {
	const [letters, setLetters] = useState("");
	const [pattern, setPattern] = useState("");
	const [size, setSize] = useState(0);
	const [max, setMax] = useState(0);

	const updateLetters = (e) => {
		let text = e.target.value.trim().toLocaleLowerCase();
		let value = "";
		for (var i = 0; i < text.length; i++) {
			let c = text.charAt(i);
			let isLetter = c >= "a" && c <= "z";
			if (isLetter) {
				value += c;
			}
		}
		setSize(value.length);
		setMax(value.length);
		setLetters(value);
		adjustPattern(value.length);
	};

	const updatePattern = (e) => {
		let possibleLetters = [];
		for (let i = 0; i < letters.length; i++) {
			let c = letters.charAt(i);
			if (c in possibleLetters) {
				++possibleLetters[c];
			} else {
				possibleLetters[c] = 1;
			}
		}
		let text = e.target.value.trim().toLocaleLowerCase();
		let value = "";
		for (let i = 0; i < text.length; i++) {
			let c = text.charAt(i);
			let isLetter = c >= "a" && c <= "z";
			let isUnderscore = c === "_";

			if (isUnderscore) {
				value += c;
			} else if (
				isLetter &&
				c in possibleLetters &&
				possibleLetters[c] > 0
			) {
				value += c;
				--possibleLetters[c];
			}
		}
		setPattern(value);
		setSize(value.length);
	};
	const adjustPattern = (param) => {
		let newPattern = pattern + "_".repeat(param);
		setPattern(newPattern.substr(0, param));
	};

	return (
		<div className="criteria">
			<form>
				<div className="form-group">
					<input
						id="letter"
						name="letter"
						onChange={updateLetters}
						type="text"
						value={letters}
						placeholder="Letters Available"
						arial-label="Letters Available"
						maxLength="20"
					/>
				</div>
				<div className="form-group">
					<input
						id="pattern"
						name="pattern"
						onChange={updatePattern}
						type="text"
						value={pattern}
						placeholder="Pattern (letter or underscore)"
						arial-label="Pattern"
						maxLength={max}
					/>
				</div>
				<div className="form-group">
					<label>Size: {size}</label>
					<input
						id="size"
						name="size"
						type="range"
						min="3"
						max={max}
						step="1"
						value={size}
						placeholder="length of word"
						onChange={(e) => {
							setSize(e.target.value);
							adjustPattern(e.target.value);
						}}
					/>
				</div>
				<div className="form-group">
					<button
						className="btnSubmit"
						type="button"
						disabled={size === 0}
						onClick={(e) => onSearch(letters, pattern, size)}
					>
						Find
					</button>
				</div>
			</form>
		</div>
	);
};

export default React.memo(Criteria);
